(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.toggleMobileMenu = {
    attach: function(context, settings) {

      enquire.register("screen and (max-width: 1008px)", {
        match : function() {
          if ($('.menu-wrapper').hasClass('processed')) {
            return;
          }


          $('.submenu').addClass('hidden');
          $('.menu-wrapper').addClass('processed');
          $('button.menu-toggler').click(function() {
            $('.menu-wrapper').toggleClass('visible');
            $('.menu-toggler').toggleClass('hidden');
          });

          $('.main-menu .menu-item--expanded span').click(function() {
            $(this).parent().find('.submenu').toggleClass('hidden');
          });
        },
        unmatch : function() {

        }
      });

    }
  };


  Drupal.behaviors.mainMenuSections = {
    attach: function(context, settings) {
      if (!$('.path-frontpage').length) {
        return false;
      }

      $('.main-menu .menu-item .is-active').each(function() {
        $(this).click(function() {
          if ($(this).hasClass('scrolling')) {
            return;
          }
          var selector = $(this).attr('href').substring(1);
          var offset = 50;

          if ($(window).width() > 767) {
            offset = 110;
          }

          if ($(window).width() > 1279) {
            offset = 160;
          }

          $('html, body').animate({
            scrollTop: $(selector).offset().top - offset
          }, 2000);

          $('.main-menu .menu-item .is-active').removeClass('scrolling');
          $(this).addClass('scrolling');

          return false;
        });
      });
    }
  };


})(jQuery, Drupal, drupalSettings);
